// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__3XUsL","triangle":"Tooltip_triangle__je3pI"};